export const CLASSES = {
  burger: '.js-burger',
  header: '.js-header',
  headerContent: '.js-header-content',
  active: 'is-active',
  loaded: 'is-loaded',
  hidden: 'is-hidden',
  open: 'is-open',
  red: 'is-red',
  sticked: 'is-sticked',
  noTouch: ' no-touch',
  slider: '.js-slider',
  sliderNext: '.js-slider-next',
  sliderPrev: '.js-slider-prev',
  tab: '.js-tab',
  tabLink: '.js-tab-link',
  scrollLink: '.js-scroll-to',
  mapSlider: '.js-map-slider',
  map: '.js-map',
  mapContent: '.js-map-content',
  mapTitle: '.js-map-title',
  pin: '.js-pin',
  videoBtn: '.js-video-btn',
};
